import React from 'react';
import styled from 'styled-components';

import { displayNumber } from '../../common/utils';

const ValueColor = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 12px;
`;
const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;
interface MonthlyPaymentChartLegentProps {
  principalAndInterest: number;
  propertyTaxes: number;
  homeownersInsurance: number;
  hoaFeesMonthly: number;
}
export const MonthlyPaymentChartLegend: React.FC<MonthlyPaymentChartLegentProps> = (props) => {
  return (
    <>
      <LegendItem>
        <ValueColor color="#1F8E87" />
        <div>
          <div>Principal & Interest</div>
          <div>
            <strong>{displayNumber(props.principalAndInterest)}</strong>
          </div>
        </div>
      </LegendItem>
      <LegendItem>
        <ValueColor color="#1E4C49" />
        <div>
          <div>Property Taxes</div>
          <div>
            <strong>{displayNumber(props.propertyTaxes)}</strong>
          </div>
        </div>
      </LegendItem>
      <LegendItem>
        <ValueColor color="#B9DDCC" />
        <div>
          <div>Homeowners Insurance</div>
          <div>
            <strong>{displayNumber(props.homeownersInsurance)}</strong>
          </div>
        </div>
      </LegendItem>
      <LegendItem>
        <ValueColor color="#DBDFE2" />
        <div>
          <div>Hoa fees</div>
          <div>
            <strong>{displayNumber(props.hoaFeesMonthly)}</strong>
          </div>
        </div>
      </LegendItem>
    </>
  );
};
